import { IMDMUnit } from '@/pages/MDM/mdm.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import css from '../unitSidePage.module.css'
import timeUtils from '@/utils/time.utils.ts'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'

interface IProps {
  unit: IMDMUnit
  onEdit: () => void
  onClose: () => void
}

const ViewUnitSidePageContent = (props: IProps) => {
  const handleDeleteUnit = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление агрегата ${props.unit.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        mdmApi.deleteUnit(props.unit.id).then((r) => r.status === 'success' && mdmEvents.unitDeleted(r.body.id)),
    })
  }

  const renderFields = () => {
    return props.unit.fields.map((f, index) => (
      <>
        <div key={f.id} className="flex-lines gap16">
          <h5 className="text-heading-5">{f.name}</h5>
          <div className={css.sidePageGrid}>
            <p className="text-nm text-secondary">Тип данных:</p>
            <p className="text-nm">{f.type}</p>
            <p className="text-nm text-secondary">Значение по умолчанию:</p>
            <p className="text-nm">{f.defaultValue || '-'}</p>
          </div>
        </div>
        {index !== props.unit.fields.length - 1 && <SeparateLine />}
      </>
    ))
  }

  return (
    <div className="flex-lines gap16 height100">
      <h4 className="text-heading-4">{props.unit.name}</h4>
      <SeparateLine />
      <div className={css.sidePageGrid}>
        <p className="text-nm text-secondary">Дата создания:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(props.unit.createdAt), 'dd MMM yyyy, HH:mm')}</p>
        <p className="text-nm text-secondary">Дата обновления:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(props.unit.updatedAt), 'dd MMM yyyy, HH:mm')}</p>
      </div>
      <SeparateLine />
      {renderFields()}
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <FormEditButton onClick={props.onEdit} />
        <FormDeleteButton onClick={handleDeleteUnit} />
      </div>
    </div>
  )
}

export default ViewUnitSidePageContent
